import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=04d761c1&scoped=true&"
import script from "./FeedbackForm.vue?vue&type=script&lang=js&"
export * from "./FeedbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d761c1",
  null
  
)

export default component.exports